export default "__VITE_ASSET__Cdz8x40p__"